import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'react-tooltip/dist/react-tooltip.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route} from "react-router-dom";
import Login from "./pages/login";
import Pdfitems from "./pages/pdfitems";
import Pdfitemcreation from "./pages/pdfitemcreation";
import SyllabusTopic from "./pages/syllabusTopic";
import Syllabus from "./pages/syllabus";
import Pdfitem from "./pages/pdfitem";
import Tutor from "./pages/tutor";	
import Tutors from "./pages/tutors";	
import Books from "./pages/books";	
import Cards from "./pages/cards";	
import Item from "./pages/item";	
import Words from "./pages/words";	
import WordAnalysis from "./pages/wordAnalysis";	
import WordSummary from "./pages/wordSummary";	
import ItemAnalysis from "./pages/itemAnalysis";	
import ArticleWordChecker from "./pages/articleWordChecker";	
import Tasks from "./pages/tasks";	
import School from "./pages/school";	
import Schools from "./pages/schools";	
import Questions from "./pages/questions";	
import Students from "./pages/students";	
import OnlineClass from "./pages/onlineClass";	
import Student from "./pages/student";	
import Customer from "./pages/customer";	
import PaperSets from "./pages/paperSets";	
import Billcsstest from "./pages/billcsstest";	
import Userwriting from "./pages/userwriting";	
import WritingAnalysis from "./pages/writingAnalysis";	
import ListeningAnalysis from "./pages/listeningAnalysis";	
import ListeningPartb from "./pages/listeningPartb";	
import ItemOrdering from "./pages/itemOrdering";	
import ItemConfig from "./pages/itemConfig";	
import BillLog from "./pages/billLog";	
import Billtest from "./pages/billtest";	
import OAuthTest from "./pages/oAuthTest";	
import SystemConfig from "./pages/systemConfig";	
import WordDetail from "./pages/wordDetail";	
	
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
		<BrowserRouter>
    <Routes>
			<Route path="/login" element={<Login />} />
      <Route path="/" element={<App />} >
				<Route path="pdfitems" element={<Pdfitems />} />
				<Route path="pdfitemcreation" element={<Pdfitemcreation />} />
				<Route path="tutors" element={<Tutors />} />
				<Route path="tutor/:tutorId" element={<Tutor />} />
				<Route path="syllabus" element={<Syllabus />} />
				<Route path="syllabus/:codeId" element={<SyllabusTopic />} />
				<Route path="pdfitem/:itemId" element={<Pdfitem />} />
				<Route path="books" element={<Books />} />
				<Route path="cards" element={<Cards />} />
				<Route path="words" element={<Words />} />
				<Route path="articleWordChecker" element={<ArticleWordChecker />} />
				<Route path="articleWordChecker/:wordId" element={<ArticleWordChecker />} />
				<Route path="tasks" element={<Tasks />} />
				<Route path="schools" element={<Schools />} />
				<Route path="school/:schoolId" element={<School />} />
				<Route path="word-detail/:wordId" element={<WordDetail />} />
				<Route path="word-analysis" element={<WordAnalysis />} />
				<Route path="word-summary" element={<WordSummary />} />
				<Route path="item-summary" element={<ItemAnalysis />} />
				<Route path="item-analysis" element={<ItemAnalysis />} />
				<Route path="questions" element={<Questions />} />
				<Route path="paperSets" element={<PaperSets />} />
				<Route path="userwriting" element={<Userwriting />} />
				<Route path="item-ordering" element={<ItemOrdering />} />
				<Route path="item-config" element={<ItemConfig />} />
				<Route path="writingAnalysis" element={<WritingAnalysis />} />
				<Route path="listening-analysis" element={<ListeningAnalysis />} />
				<Route path="listening-partb/:id" element={<ListeningPartb />} />
				<Route path="students" element={<Students />} />
				<Route path="onlineClass" element={<OnlineClass />} />
				<Route path="student/:userId" element={<Student />} />
				<Route path="customer/:userId" element={<Customer />} />
				<Route path="bill" element={<Billcsstest />} />
				<Route path="oAuthTest" element={<OAuthTest />} />
				<Route path="generalitem/:itemId" element={<Item />} />
				<Route path="log" element={<BillLog />} />
				<Route path="systemConfig" element={<SystemConfig />} />
				<Route path="billtest" element={<Billtest />} />
				<Route
					path="*"
					element={
						<main style={{ padding: "1rem" }}>
							<p>There's nothing here!</p>
						</main>
					}
				/>
			</Route>
    </Routes>
		</BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
